import { Group, Button, NumberInput, Text } from '@mantine/core';
import { useForm } from '@mantine/form';

import { formatAmount } from '@/shared';

import type { TPaymentApproveParams, TPayment } from '../store/types';

type FormData = TPaymentApproveParams;

type Props = {
  payment: TPayment;
  onSubmit: (params: TPaymentApproveParams) => void;
  onClose: () => void;
};

export const PaymentApproveForm = (props: Props) => {
  const { payment, onSubmit, onClose } = props;
  const isCallbackApproval = payment.status === 'approved_delay' || payment.status === 'approved_wrong_amount';

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      paymentId: payment.id,
      paidAmount: isCallbackApproval ? payment.paidAmount : payment.amount,
    },
    validate: {
      paymentId: (value) => !value ? 'Введите ID платежа' : null,
      paidAmount: (value) => !value ? 'Введите оплаченную сумму' : null,
    },
  });

  const handleSubmit = (values: FormData) => {
    const params: TPaymentApproveParams = {
      paymentId: values.paymentId,
      paidAmount: values.paidAmount,
    };
    onSubmit(params);
    onClose();
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <NumberInput
        label="ID платежа"
        withAsterisk
        disabled
        key={form.key('paymentId')}
        {...form.getInputProps('paymentId')}
      />
      {payment.uniqueAmount && (
        <Text size="sm" mt="sm">
          К переводу: {formatAmount(payment.uniqueAmount)} {payment.uniqueCurrency}.
          При точной оплате зачисляется исходная сумма заказа.
        </Text>
      )}
      <NumberInput
        label={`Оплаченная сумма (${payment.currency})`}
        withAsterisk
        thousandSeparator=" "
        key={form.key('paidAmount')}
        {...form.getInputProps('paidAmount')}
      />

      <Group justify="flex-start" mt="30">
        <Button onClick={onClose} variant="outline">
          Отмена
        </Button>
        <Button type="submit">
          Подтвердить
        </Button>
      </Group>
    </form>
  );
};
